function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  &.bordered {\n    border-bottom: 1px solid ", ";\n  }\n  .acc-title-wrapper {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    outline: none;\n    padding: 15px 10px;\n  }\n  .acc-title {\n    cursor: pointer;\n    color: ", ";\n    outline: none !important;\n    &::selection {\n      background-color: ", ";\n    }\n  }\n  .acc-title-icon-wrapper {\n    margin: 10px 10px 10px 0;\n  }\n  .acc-expand-icon-wrapper {\n    margin-left: auto;\n    &.open {\n      transform: rotate(180deg);\n    }\n  }\n  .acc-sub-title {\n    cursor: pointer;\n    padding: 2px 10px;\n  }\n  .acc-outer-content {\n    &.open .acc-inner-content {\n      max-height: 100vh;\n      transition: max-height 0.5s linear;\n    }\n    .acc-inner-content {\n      max-height: 0;\n      transition: max-height 0.5s linear;\n      overflow: hidden;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '../../atoms/Icon';
import Text from '../../atoms/Text';
import { defaultTheme } from '../../../utils';
import ChevronDown from '../../../assets/icons/chevron-down.svg';
export var AccordionWrapper = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.border;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.text.bodyTextDark;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.primary;
});

var Accordion = function Accordion(_ref4) {
  var classProp = _ref4.classProp,
      clickHandler = _ref4.clickHandler,
      open = _ref4.open,
      variant = _ref4.variant,
      titleIcon = _ref4.titleIcon,
      expandIcon = _ref4.expandIcon,
      title = _ref4.title,
      subtitle = _ref4.subtitle,
      children = _ref4.children,
      rest = _objectWithoutPropertiesLoose(_ref4, ["classProp", "clickHandler", "open", "variant", "titleIcon", "expandIcon", "title", "subtitle", "children"]);

  var _useState = useState(open),
      isOpen = _useState[0],
      toggle = _useState[1];

  var onClickHandler = function onClickHandler() {
    toggle(!isOpen);

    if (clickHandler) {
      clickHandler();
    }
  };

  useEffect(function () {
    toggle(open);
  }, [open]);
  return /*#__PURE__*/React.createElement(AccordionWrapper, _extends({
    className: variant + " " + classProp
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "acc-title-wrapper",
    onClick: onClickHandler,
    onKeyPress: function onKeyPress() {
      return onClickHandler();
    },
    role: "button",
    tabIndex: 0
  }, titleIcon ? /*#__PURE__*/React.createElement("span", {
    className: "acc-title-icon-wrapper"
  }, /*#__PURE__*/React.createElement(Icon, {
    path: titleIcon
  })) : null, /*#__PURE__*/React.createElement(Text, {
    referenceClass: "acc-title",
    text: title
  }), /*#__PURE__*/React.createElement("div", {
    className: "acc-expand-icon-wrapper " + (isOpen ? 'open' : '')
  }, /*#__PURE__*/React.createElement(Icon, {
    path: expandIcon
  }))), subtitle ? /*#__PURE__*/React.createElement(Text, {
    referenceClass: "acc-sub-title",
    text: subtitle
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: isOpen ? 'acc-outer-content open' : 'acc-outer-content'
  }, /*#__PURE__*/React.createElement("div", {
    className: "acc-inner-content"
  }, children)));
};

Accordion.propTypes = process.env.NODE_ENV !== "production" ? {
  open: PropTypes.bool,
  clickHandler: PropTypes.func,
  variant: PropTypes.string,
  titleIcon: PropTypes.string,
  expandIcon: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node
} : {};
Accordion.defaultProps = {
  variant: '',
  classProp: '',
  open: false,
  theme: defaultTheme,
  expandIcon: ChevronDown
};
export default Accordion;